import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { ORDERS_LIST_CONTAINER_VERTICAL_GAP } from '~pages/Approvals/DriverPayV2/constants';

interface TableHeaderProps {
  sx?: SxProps<Theme>;
  title?: string;
}

export default function TableHeader({ sx, title }: TableHeaderProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          alignItems: 'center',
          bgcolor: theme.semantic.surfaceSunken,
          borderBottom: `solid 1px ${theme.palette.divider}`,
          borderTop: `solid 1px ${theme.palette.divider}`,
          display: 'flex',
          height: '100%',
          overflow: 'hidden',
          position: 'sticky',
          top: `calc(0px - ${ORDERS_LIST_CONTAINER_VERTICAL_GAP} - 1px)`,
          zIndex: 10,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {title && <OverflowAwareText sx={{ fontWeight: 600 }}>{title}</OverflowAwareText>}
    </Box>
  );
}
